import instance from '../helpers/interceptor';

export const getErrorLogs = async (date) => {
  return await instance.post('/audit/errorlogs', { date });
};

export const getLoginLogs = async (date) => {
  return await instance.post('/audit/loginlogs', { date });
};

export const getAuditTrail = async (date, masterFilter) => {
  return await instance.post('/audit/audittrail', { date, masterFilter });
};

export const logFrontendError = async (errorData) => {
  try {
    await instance.post('/audit/logerror', errorData);
  } catch {
    // Silently fail
  }
};

export const logLoginEvent = async (logData) => {
  try {
    await instance.post('/audit/loglogin', logData);
  } catch {
    // Silently fail
  }
};
